import React from "react";

const NoDataAvailable = ({
  title = "No Data Available", 
  description = "Data will appear here once loaded",
  height = "200px",
  iconSize = "48px",
  titleColor = "#8C8C8C",
  descriptionColor = "#BFBFBF"
}) => {
  return (
    <div 
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: height,
        flexDirection: "column",
        textAlign: "center",
        padding: "20px"
      }}
    >
      <div 
        style={{
          fontSize: iconSize,
          color: "#D9D9D9",
          marginBottom: "16px"
        }}
      >
        📊
      </div>
      <p 
        style={{
          fontSize: "16px",
          color: titleColor,
          marginBottom: "8px",
          fontWeight: "500"
        }}
      >
        {title}
      </p>
      <p 
        style={{
          fontSize: "14px",
          color: descriptionColor,
          margin: "0",
          maxWidth: "300px",
          lineHeight: "1.4"
        }}
      >
        {description}
      </p>
    </div>
  );
};

export default NoDataAvailable;
